import { logStartGreyError } from 'owa-analytics-start';
import { INTERNAL_ONLY_SYSTEM_METADATA_GLOBAL_ACCOUNT } from 'owa-analytics-types';
import type { MailboxInfo } from 'owa-client-types';
import type DistinguishedFolderIdName from 'owa-service/lib/contract/DistinguishedFolderIdName';
import folderIdToName from './folderIdToName';

export default function doesFolderIdEqualName(
    folderId: string,
    distinguishedFolderName: DistinguishedFolderIdName,
    mailboxInfo?: MailboxInfo,
    shouldSearchShared?: boolean
): boolean {
    if (!folderId) {
        const error = new Error('DoesFolderIdEqualNameInvalidParameters');
        // This utility is invoked from many call sites; some have access to a MailboxInfo and some
        // do not. When a caller provides one we use it; otherwise we fall back to the global routing
        // constant so the telemetry call is never made with `undefined` (which would be disabled
        // under MailboxInfo enforcement).
        logStartGreyError(
            'DoesFolderIdEqualNameInvalidParameters',
            mailboxInfo ?? INTERNAL_ONLY_SYSTEM_METADATA_GLOBAL_ACCOUNT,
            error
        );

        return false;
    }

    return folderIdToName(folderId, shouldSearchShared) === distinguishedFolderName;
}
